import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Lightbulb } from "@faire/web/slate/icons/foundation/Lightbulb";
import React from "react";
import { HowDoesSignupWorkIA } from "../instantAnswers/referrals-HowDoesSignupWork";
import { WhenDoesSignupExpireIA } from "../instantAnswers/referrals-whenDoesSignupExpire";
export var useHowFaireWorksRetailerNodes = function useHowFaireWorksRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    HowFaireWorks: {
      id: "HowFaireWorks",
      label: strictLocalize({
        id: "VX1YoC",
        defaultMessage: [{
          "type": 0,
          "value": "Como funciona a Faire"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Lightbulb, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.FAQ.RETAILER_WHAT_IS_FAIRE, articles.PaymentsAndInvoices.NET_60_TERMS, articles.MyOrders.FAIRE_PROTECTION, articles.GettingStarted.RESELLER_ID],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "oKX21f",
        defaultMessage: [{
          "type": 0,
          "value": "Como funciona a Faire"
        }]
      }),
      children: ["FaireDirectSignUpOffer"]
    },
    FaireDirectSignUpOffer: {
      id: "FaireDirectSignUpOffer",
      label: strictLocalize({
        id: "kBocXv",
        defaultMessage: [{
          "type": 0,
          "value": "Oferta de boas-vindas Faire Direct"
        }]
      }),
      children: ["HowToClaimOffer", "OfferExpiration", "DidNotReceiveSignUpOffer"],
      level: 2
    },
    HowToClaimOffer: {
      id: "HowToClaimOffer",
      label: strictLocalize({
        id: "gbMovV",
        defaultMessage: [{
          "type": 0,
          "value": "Como obter a oferta"
        }]
      }),
      articles: [articles.Referrals.USE_REFERRAL_PROMOTION],
      instantAnswer: HowDoesSignupWorkIA(strictLocalize),
      level: 3
    },
    OfferExpiration: {
      id: "OfferExpiration",
      label: strictLocalize({
        id: "aZCE2z",
        defaultMessage: [{
          "type": 0,
          "value": "Data de validade da oferta"
        }]
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    },
    DidNotReceiveSignUpOffer: {
      id: "DidNotReceiveSignUpOffer",
      label: strictLocalize({
        id: "0/6/RI",
        defaultMessage: [{
          "type": 0,
          "value": "Não recebi a oferta de inscrição"
        }]
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    }
  };
};